const {
  createCarouselView,
  HORIZONTAL,
  PAGE_SHOWN_EVENT,
  LAST_PAGE_EVENT,
  NEXT_EVENT,
  PREV_EVENT,
  READY_EVENT,
  SWIPE_EVENT,
} = require('@component/carousel');
const ProductPoolMediaView = require('./ProductPoolMedia');
const template = require('../templates/partials/component-product-pool-media/carousel.hbs');

let idConsecutive = 0;

function renderCarouselItems(collection, ItemView) {
  return collection.map(model => new ItemView({ model }).render().$el.get(0));
}

function registerItems(collection, productPool) {
  const pool = productPool;
  if (collection) {
    collection.forEach((carouselModel) => {
      const model = carouselModel;
      let id = model.id || model.cid;
      if (!id) {
        idConsecutive += 1;
        id = idConsecutive;
        model.cid = id;
      }
      if (!pool[id]) {
        pool[id] = model;
        pool.allItemIds.push(id);
      }
    });
  }
}

function generateAnalyticsData(data, allItemsId) {
  const { current, childPerPage } = data;
  // current page is 0 based
  const end = current * childPerPage;
  const pageIds = allItemsId.slice(end - childPerPage, end);
  const pageIdsPos = [];
  for (let i = 0; i < pageIds.length; i += 1) {
    // +1 to make pos 1 based
    const pos = ((current - 1) * childPerPage) + i + 1;
    pageIdsPos.push({ id: pageIds[i], pos });
  }
  return Object.assign({}, data, { pageIdsPos });
}

module.exports = ProductPoolMediaView.extend({
  template,
  initialize(opts) {
    ProductPoolMediaView.prototype.initialize.apply(this, [opts]);
    this.itemsPool = {
      allItemIds: [],
    };
    this.setChildView(opts);
  },
  setChildView(opts = {}) {
    if (opts.childView) {
      this.childView = opts.childView;
    } else {
      const ProductThumbnailView = require(`@component/product-thumbnail/src/views/${process.env.ENTRY_POINT}/ProductThumbnail`).default;
      const thumbnailOpts = { tagName: 'li' };
      if (opts.poolParams) {
        thumbnailOpts.options = { pageMeta: { properties: opts.poolParams.thumbnailAttrs.props } };
      }
      this.childView = ProductThumbnailView.extend(thumbnailOpts);
      console.log('No childview present');
    }
  },
  onRender() {
    try {
      const itemsCollection = this.model.get('productPoolMedia').collection;
      // Trim long product names.
      if (itemsCollection) {
        this.trimLongProductNames(itemsCollection);
      }

      registerItems(itemsCollection, this.itemsPool);
      const carouselItems = renderCarouselItems(itemsCollection, this.childView);

      const opts = this.buildCarouselOpts(carouselItems);
      this.carouselView = createCarouselView(opts.carouselType, opts);
      this.carouselView.on(PAGE_SHOWN_EVENT, (args) => {
        this.triggerMethod(PAGE_SHOWN_EVENT, generateAnalyticsData(args, this.itemsPool.allItemIds));
      });
      [LAST_PAGE_EVENT, NEXT_EVENT, PREV_EVENT, READY_EVENT, SWIPE_EVENT].forEach((event) => {
        this.carouselView.on(event, (args) => {
          this.triggerMethod(event, args);
        });
      });

      this.carouselView.render();
    } catch (e) {
      console.error(e);
    }
  },
  buildCarouselOpts(carouselItems) {
    return Object.assign(
      {},
      {
        el: this.$('.product-pool-media-carousel')[0],
        childrenView: carouselItems,
        carouselType: HORIZONTAL,
      },
      this.options.config,
    );
  },
  addNextPageItems(items) {
    if (items) {
      this.trimLongProductNames(items);
      registerItems(items, this.itemsPool);
      const htmlItems = renderCarouselItems(items, this.childView);
      this.carouselView.addChildren(htmlItems);
    }
  },
  moveToFirstPage() {
    this.carouselView.moveToFirstPage();
  },
  triggerNextEvent() {
    this.carouselView.triggerNextEvent();
  },
  trimLongProductNames(items) {
    items.forEach((item) => {
      const product = item.get('product');
      let { name } = product.detail;
      const title = name;
      if (name.length > 26) {
        name = `${name.substring(0, 26)}...`;
      }
      product.detail.title = title;
      product.detail.name = name;
      item.set('product', product, { silent: true });
    });
  },
  bootstrap() {
    this.setChildView();
    this.onRender();
  },
  onBeforeDestroy() {
    this.carouselView.dispose();
  },
  setEndOfData(val) {
    this.carouselView.setEndOfData(val);
  },
});
